import { coreService } from "../../../services/coreService";
import { FirstArgumentType } from "../../../types/ArgumentTypes";
import { buildQuery } from "../../../lib/network";

export type InspectionSectionType = Awaited<
  ReturnType<typeof coreService.inspectionsTypesDetail>
>["data"]["included"][number];
export type InspectionItemType = InspectionSectionType["attributes"]["items"][number];

export const getInspectionType =
  (headers: any) =>
  (
    id: FirstArgumentType<typeof coreService.inspectionsTypesDetail>,
    query: { deleted: boolean } = { deleted: false },
  ) => {
    return buildQuery(
      coreService.inspectionsTypesDetail(id, { deleted: query.deleted.toString() }, { headers }),
      (response) => {
        return response.data;
      },
    );
  };
